import { BUSCAR_IMPOSTOS_EMPRESA } from '../../actions/types'

const initialState = {
  impostoEmpresa: null,
  impostosEmpresa: null
}

export default function reducerImpostoEmpresa (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_IMPOSTOS_EMPRESA: {
      return {
        ...state,
        impostosEmpresa : action.payload.data
      }
    }

    default: {
      return state
    }
  }
}
